import { Call } from "./call";

export class Calls extends Array<Call> {
  constructor(calls?: Call[]) {
    super();
    if (calls instanceof Array) calls.forEach((call) => this.push(call));
  }

  public get(call_id: string): Call | undefined {
    return this.find((call) => call.call_id == call_id);
  }

  public update(newCall: Call): Calls {
    if (this.get(newCall.call_id) === undefined)
      return new Calls([...this, newCall]);
    return new Calls(
      this.map((call) => (call.call_id === newCall.call_id ? newCall : call)),
    );
  }

  public sortedByCreatedAt(): Calls {
    return new Calls(
      [...this].sort((a, b) => {
        if (!a.local_created_at && !b.local_created_at) return 0;
        else if (!a.local_created_at) return 1;
        else if (!b.local_created_at) return -1;
        return b.local_created_at.getTime() - a.local_created_at.getTime();
      }),
    );
  }

  public sortedByUpdatedAt(): Calls {
    return new Calls(
      [...this].sort((a, b) => {
        if (!a.local_updated_at && !b.local_updated_at) return 0;
        else if (!a.local_updated_at) return 1;
        else if (!b.local_updated_at) return -1;
        return b.local_updated_at.getTime() - a.local_updated_at.getTime();
      }),
    );
  }
}
